// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".kpisWrapper[data-v-64809933]{display:grid;-webkit-box-pack:stretch;-ms-flex-pack:stretch;justify-content:stretch;grid-template-columns:1fr 1fr 1fr 1fr}", ""]);
// Exports
module.exports = exports;
